import update from 'react-addons-update';
import {
	PROFILE_CLEAR,
	PROFILE_GET_AGENT_SUCCESS,
	PROFILE_PUT_AGENT_SUCCESS,
	PROFILE_UPDATE_AGENT_INFO,
	PROFILE_POST_ERROR,
	PROFILE_CLEAR_ERROR,
} from './action.js';

const initState = {
	action: null,
	agentInfo: null,
	errors: null,
	showSuccessDialog: false
};

export default function profileReducer(state = initState, action) {
	switch (action.type) {
		case PROFILE_GET_AGENT_SUCCESS:
			let initAgentInfo = JSON.parse(JSON.stringify(action.data));

			initAgentInfo.confirmEmail = initAgentInfo.email;

			// 若addressState為空，則塞入預設值
			if (!initAgentInfo.addressState) initAgentInfo.addressState = 'OTH';

			// 若無mobilePhone資料則塞入空字串
			if (!initAgentInfo.mobilePhone) {
				initAgentInfo.mobilePhone = {
					id: null,
					number: '',
					dialCode: ''
				};
			}
			// 若無workPhone資料則塞入空字串
			if (!initAgentInfo.workPhone) {
				initAgentInfo.workPhone = {
					id: null,
					number: '',
					dialCode: ''
				};
			}

			return update(state, {
				agentInfo: { $set: initAgentInfo }
			});
		case PROFILE_PUT_AGENT_SUCCESS:
			return update(state, {
				showSuccessDialog: { $set: true }
			});
		case PROFILE_UPDATE_AGENT_INFO:
			return update(state, {
				agentInfo: { $set: action.data }
			});
		case PROFILE_POST_ERROR:
      return update(state, {
        errors: { $set: action.errors }
      });
    case PROFILE_CLEAR_ERROR:
      return update(state, {
        errors: { $set: initState.errors }
      });
		case PROFILE_CLEAR:
			return initState;
		default:
			return state;
	}
}